<ngx-popover
  [bindTo]="bindTo"
  [middleware]="popovermiddleware"
  [placement]="'top'"
>
  <button class="quality-control-selector">
    <img src="assets/static/icons/settings.svg" alt="Control de calidad del video" />
  </button>

  <ng-template ngx-popover-template>
    <div class="quality-selector-popover" *ngIf="isMouseHoveringVideo()">
      @for (item of videoPlayerComponent.getVideoSources(); track $index) {
      <button
        class="quality-selector-item"
        [ngClass]="{
          'quality-selector-item-active':
            item === videoPlayerComponent.selectedVideoSource
        }"
        (click)="videoPlayerComponent.setVideoSource(item)"
      >
        <div class="quality-selector-label">
          <div>{{ item.label }}</div>
        </div>
      </button>
      }
    </div>
  </ng-template>
  <ngx-arrow padding="8" class="popover-arrow" *ngIf="isMouseHoveringVideo()" />
</ngx-popover>
